export const courseDetails = [
  {
    id: 'ai-basics',
    title: 'AI基础入门班',
    tagline: '零基础到AI入门，30天系统蜕变',
    description: '专为零编程基础学员设计的人工智能入门课程。从Python编程基础开始，逐步深入到机器学习核心概念，通过实战小项目巩固学习成果，建立扎实的AI知识体系。',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20minimalist%20coding%20workspace%20with%20warm%20ambient%20lighting%2C%20laptop%20displaying%20abstract%20code%20patterns%2C%20notebook%20and%20coffee%20on%20wooden%20desk%2C%20soft%20cream%20and%20warm%20amber%20accents%2C%20elegant%20editorial%20photography%20style%2C%20calm%20focused%20atmosphere%2C%20no%20text&width=1200&height=700&seq=course-detail-basics&orientation=landscape',
    price: 399,
    originalPrice: 599,
    duration: '4周',
    totalHours: 48,
    students: 3256,
    rating: 4.9,
    reviewCount: 852,
    level: '入门',
    features: [
      'Python编程基础',
      '数据分析入门',
      '机器学习原理',
      '实战小项目',
      '社群答疑支持',
      '30天无限次回看',
      '结业证书',
    ],
    curriculum: [
      { week: '第1周', title: 'Python编程基础', topics: ['Python环境搭建', '变量与数据类型', '流程控制语句', '函数与模块'] },
      { week: '第2周', title: '数据处理与分析', topics: ['NumPy基础', 'Pandas数据处理', '数据可视化', '实战：电商数据分析'] },
      { week: '第3周', title: '机器学习入门', topics: ['机器学习概述', '监督学习基础', '分类与回归算法', '实战：房价预测'] },
      { week: '第4周', title: '综合实战与结业', topics: ['模型评估与调优', '特征工程入门', '综合项目实战', '学习路径规划'] },
    ],
    whoIsThisFor: [
      '完全零编程基础的初学者',
      '想转行AI领域的职场人士',
      '对人工智能感兴趣的学生',
      '希望建立AI知识体系的产品经理',
    ],
  },
  {
    id: 'ml-practical',
    title: '机器学习实战班',
    tagline: '深入ML核心技术，10个项目打造竞争力',
    description: '系统深入地学习机器学习核心算法与工程实践。涵盖监督学习、无监督学习、特征工程、模型优化等核心技术，通过10个真实企业级项目积累丰富的实战经验。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20data%20science%20workspace%20with%20warm%20golden%20lighting%2C%20multiple%20screens%20showing%20data%20visualizations%20and%20charts%2C%20clean%20wooden%20desk%20setup%2C%20soft%20cream%20and%20amber%20tones%2C%20elegant%20editorial%20photography%2C%20sophisticated%20professional%20atmosphere%2C%20no%20text&width=1200&height=700&seq=course-detail-ml&orientation=landscape',
    price: 699,
    originalPrice: 999,
    duration: '8周',
    totalHours: 96,
    students: 2189,
    rating: 4.8,
    reviewCount: 623,
    level: '中级',
    features: [
      '监督学习算法精讲',
      '无监督学习与聚类',
      '特征工程实战',
      '模型评估与优化',
      '10个企业级项目',
      '一对一导师辅导',
      '简历优化指导',
      '90天无限次回看',
    ],
    curriculum: [
      { week: '第1-2周', title: '监督学习精讲', topics: ['线性回归与逻辑回归', '决策树与随机森林', 'SVM支持向量机', '实战：客户流失预测'] },
      { week: '第3-4周', title: '无监督学习与特征工程', topics: ['K-Means与层次聚类', 'PCA降维技术', '特征选择与构造', '实战：用户分群分析'] },
      { week: '第5-6周', title: '模型优化与工程化', topics: ['交叉验证与超参调优', '集成学习方法', '模型部署基础', '实战：推荐系统搭建'] },
      { week: '第7-8周', title: '综合项目实战', topics: ['端到端ML项目流程', 'NLP文本分类实战', '时间序列预测', '毕业项目答辩'] },
    ],
    whoIsThisFor: [
      '有Python基础的开发者',
      '希望提升ML实战能力的数据分析师',
      '准备转行机器学习工程师的求职者',
      '想系统学习ML工程化的在校学生',
    ],
  },
  {
    id: 'dl-advanced',
    title: '深度学习进阶班',
    tagline: '前沿DL技术，把握AI最新浪潮',
    description: '深入学习神经网络、CNN、RNN、Transformer等前沿深度学习技术。掌握PyTorch和TensorFlow两大主流框架，学习模型部署与优化，成为具备工业级深度学习能力的AI工程师。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20tech%20workspace%20with%20warm%20ambient%20light%2C%20neural%20network%20abstract%20visualization%20on%20large%20screen%2C%20clean%20modern%20desk%20with%20notebooks%2C%20soft%20cream%20and%20golden%20amber%20palette%2C%20sophisticated%20editorial%20photography%20style%2C%20calm%20focused%20environment%2C%20no%20text&width=1200&height=700&seq=course-detail-dl&orientation=landscape',
    price: 999,
    originalPrice: 1399,
    duration: '12周',
    totalHours: 144,
    students: 1567,
    rating: 4.9,
    reviewCount: 438,
    level: '高级',
    features: [
      '神经网络架构精讲',
      'CNN/RNN/Transformer',
      'PyTorch与TensorFlow',
      '大规模模型训练',
      '模型部署与优化',
      '顶会论文解读',
      '20+实战项目',
      '终身无限次回看',
    ],
    curriculum: [
      { week: '第1-3周', title: '深度学习基础', topics: ['神经网络原理', '反向传播与优化器', 'PyTorch框架精讲', '实战：图像分类器'] },
      { week: '第4-6周', title: '计算机视觉', topics: ['CNN架构演进', '目标检测与分割', '图像生成模型', '实战：自动驾驶感知'] },
      { week: '第7-9周', title: '自然语言处理', topics: ['RNN/LSTM/GRU', 'Attention机制', 'Transformer架构', '实战：对话机器人'] },
      { week: '第10-12周', title: '前沿技术与部署', topics: ['大语言模型原理', '模型压缩与量化', '云端部署实战', '毕业项目：端到端AI产品'] },
    ],
    whoIsThisFor: [
      '有ML基础的工程师',
      '希望深入学习DL的研究生',
      '想掌握大模型技术的开发者',
      '准备面试AI岗位的求职者',
    ],
  },
];

export const courseFaqs = [
  {
    question: '课程适合零基础学员吗？',
    answer: 'AI基础入门班专为零基础学员设计，从Python编程基础开始教学。我们80%的学员入学前没有任何编程经验，经过系统学习后都成功掌握了AI核心技能。',
  },
  {
    question: '课程有效期是多久？',
    answer: '基础入门班支持30天无限次回看，专业进阶班支持90天回看，全栈大师班享受终身回看权益。所有课程视频均可反复观看，确保你完全掌握每个知识点。',
  },
  {
    question: '是否有课后作业和项目？',
    answer: '每周围绕核心知识点设计实践作业，课程中穿插多个项目实战。我们强调"学以致用"，每个学员在结业时都会拥有完整的AI项目作品集。',
  },
  {
    question: '导师答疑是如何进行的？',
    answer: '专业进阶班和全栈大师班提供一对一导师辅导。你可以在专属学习社群中随时提问，导师会在24小时内给予详细解答。每周还有固定的直播答疑时间。',
  },
  {
    question: '完成课程后能获得证书吗？',
    answer: '所有完成课程的学员都会获得bbgpt.online颁发的结业证书。全栈大师班学员还可申请参加AI工程师认证考试，通过后将获得行业认可的AI工程师认证。',
  },
  {
    question: '购买后可以退款吗？',
    answer: '课程属于数字化知识服务产品，购买后默认不予退款。仅在学员本人因长期住院、重大疾病或意外事故导致无法继续学习，并能提供有效官方证明文件时，方可申请特殊退款审核。详情请参阅我们的退款政策页面。',
  },
];

export const courseComparisonData = {
  headers: ['对比项目', '基础入门', '专业进阶', '全栈大师'],
  rows: [
    { label: '课程数量', values: ['1门课程', '2门课程', '3门全部课程'] },
    { label: '学习周期', values: ['4周', '8周', '12周'] },
    { label: '项目实战', values: ['1个项目', '10个项目', '20+项目'] },
    { label: '回看期限', values: ['30天', '90天', '终身'] },
    { label: '导师辅导', values: ['社群答疑', '1v1辅导', '顶级导师1v1'] },
    { label: '就业服务', values: ['—', '简历优化', '名企内推'] },
    { label: '证书', values: ['结业证书', '结业证书', 'AI工程师认证'] },
    { label: '价格', values: ['¥399', '¥699', '¥999'] },
  ],
};